import { IGeneratedDevice, IGroupedDevices, ISimulateResponse } from './types';

export const mapSimulateResponse = (res: ISimulateResponse): IGroupedDevices => {
  const toDevices = (
    items: ISimulateResponse['devices'][keyof ISimulateResponse['devices']],
    category: IGeneratedDevice['testCategory']
  ): IGroupedDevices[IGeneratedDevice['testCategory']] => {
    let autoGeneratedCount = 0,
      serialItems: IGroupedDevices[IGeneratedDevice['testCategory']]['serialItems'] = [];
    items.forEach((item) => {
      autoGeneratedCount += item.isAutomated ? 1 : 0;
      serialItems.push({
        serialId: item.serial,
        isAutoGenerated: item.isAutomated,
      });
    });
    return {
      serialItems,
      autoGeneratedCount,
      preExistingCount: serialItems.length - autoGeneratedCount,
      testCategory: category,
      totalCount: serialItems.length,
    };
  };

  return {
    Match: toDevices(res.devices.MATCH, 'Match'),
    'Mismatch - Functional': toDevices(res.devices.MISMATCH_FUNCTIONAL, 'Mismatch - Functional'),
    'Mismatch - Non-Functional': toDevices(
      res.devices.MISMATCH_NONFUNCTIONAL,
      'Mismatch - Non-Functional'
    ),
  };
};
